// see: https://codebyzach.github.io/pace/docs/
import pace from 'pace-js'

document.addEventListener('DOMContentLoaded', () => {
    // display progress bar (currently broken on Firefox)
    pace.start()
})
